import { create } from 'zustand';

type MarqueeZoneState = {
  id: string;
  number: number;
} | null;

interface MarqueeZoneStore {
  sourceAddToZone: MarqueeZoneState;
  setSourceAddToZone: (newState: MarqueeZoneState) => void;

  targetAddToZone: MarqueeZoneState;
  setTargetAddToZone: (newState: MarqueeZoneState) => void;

  pendingTargetMarqueeZoneNumber: number;
  setPendingTargetMarqueeZoneNumber: (newState: number) => void;
}

export const useMarqueeZoneStateStore = create<MarqueeZoneStore>((set, get) => ({
  sourceAddToZone: null,
  setSourceAddToZone: (newState: MarqueeZoneState) => {
    set(() => ({
      sourceAddToZone: newState,
    }));
  },
  targetAddToZone: null,
  setTargetAddToZone: (newState: MarqueeZoneState) => {
    set(() => ({
      targetAddToZone: newState,
    }));
  },
  pendingTargetMarqueeZoneNumber: 0,
  setPendingTargetMarqueeZoneNumber: (zoneNumber: number) => {
    set(() => ({
      pendingTargetMarqueeZoneNumber: zoneNumber,
    }));
  },
}));
